import React from 'react';
import { Redirect } from 'react-router-dom';

const Identity = () => (
    <Redirect to='/identity/users' />
);

export default Identity;